module.exports = __webpack_public_path__ + "ea760d4d43cf4531534dfc5138f48f94.png";